'use client'
import { PaginationSkeleton } from '@morpho-org/ui-v6/client'
import { Skeleton } from '@morpho-org/ui-v6/server'
import { type CSSProperties, memo } from 'react'

import { SubSectionTitle } from '@/components/common/SubSectionTitle'

export interface VaultTableLoadingProps {
  title: string
  tableHeight?: CSSProperties['height']
}

const VaultTableLoading = ({ title, tableHeight = '338px' }: VaultTableLoadingProps) => {
  return (
    <div className="gap-sm flex flex-col">
      <SubSectionTitle>{title}</SubSectionTitle>
      <div className="gap-xs flex flex-col">
        <Skeleton
          className="w-[100%] rounded-[20px]"
          style={{
            height: tableHeight
          }}
        />
        <PaginationSkeleton />
      </div>
    </div>
  )
}

export default memo(VaultTableLoading)
